import * as React from "react";
const SvgEdit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <g clipPath="url(#edit_svg__a)">
      <path
        stroke="#2D2D2D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.25}
        d="M7.918 2.773a4.555 4.555 0 0 0 4.052 3.829M1.31 15.375H14.69M8.937 1.695l-6.104 6.46c-.23.246-.454.73-.498 1.064l-.276 2.409c-.096.87.528 1.464 1.39 1.316l2.395-.41c.334-.059.803-.304 1.033-.557l6.104-6.46c1.056-1.116 1.532-2.387-.111-3.941C11.234.037 9.992.58 8.937 1.695"
      />
    </g>
    <defs>
      <clipPath id="edit_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEdit;
